export default "__VITE_ASSET__BKBONxFP__"